import React from 'react';
import CategoryCard from './CategoryCard';
import { categories } from '../../data/categories';
import { useLanguage } from '../../contexts/LanguageContext';

const CategoryGrid = ({ onSelectCategory }) => {
  const { t } = useLanguage();
  
  return (
    <div className="category-container animate-fadeIn">
      <div className="welcome-section">
        <h2 className="animate-slideInLeft">{t('appTitle')} 🎉</h2>
        <p className="animate-slideInRight">{t('quiz.selectCategory')}</p>
      </div>
      
      <div className="category-grid">
        {categories.map((category, index) => (
          <div 
            key={category.id}
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <CategoryCard 
              category={category} 
              onSelect={onSelectCategory}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryGrid;
